import { render, staticRenderFns } from "./DetailedFeatures.vue?vue&type=template&id=13cc63da&scoped=true&"
import script from "./DetailedFeatures.vue?vue&type=script&lang=js&"
export * from "./DetailedFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DetailedFeatures.vue?vue&type=style&index=0&id=13cc63da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc63da",
  null
  
)

export default component.exports